import { ajax } from '../../../services/helper'
class ApiService {

    getEmployeePromotionData = (from,to,city_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeePromotions/list?from="+from+"&to="+to+"&city_id="+city_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

   
    getEmployeePromotionById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeePromotions/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    validateEmployeePromotion = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeePromotions/validateDeputy"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    getEmployeeById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/"+id+"/view"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    addEmployeePromotion = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeePromotions/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    editEmployeePromotion = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeePromotions/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Employee Promotion/services/apiservices.js